import { endPoints, getAuthServiceEndPoint } from "./base-url/api-constants";
import { apiService } from "./base-api-service/base-api-service";

class AuthService {
  AuthService(url: any) {
    return getAuthServiceEndPoint(url);
  }

  AuthenticateUser(data: any) {
    const authEndpoint = this.AuthService(`${endPoints.authService.USER_AUTH}`);
    return apiService.post(authEndpoint, data);
  }
  LoginUser(data: any) {
    const authEndpoint = this.AuthService(`${endPoints.authService.LOGIN_USER_AUTH}`);
    return apiService.post(authEndpoint, data);
  }
  GetServiceTokenForUnAuthUser(data: any) {
    const unAuthEndpoint = this.AuthService(`${endPoints.authService.UNAUTH_USER}`);
    return apiService.post(unAuthEndpoint, data);
  }
}

export default new AuthService();
